/**
 * Normalize a user-entered URL for use as an `<a href>`.
 *
 * Protocol-less values like `example.com` are path-relative in the browser, so on
 * `https://profile.up2promo.com/acme/jane` they resolve to
 * `https://profile.up2promo.com/acme/example.com`. Prepend `https://` when needed.
 */
export function toExternalHref(raw: string): string {
  const url = raw.trim();
  if (!url) return '';
  if (/^(https?:|mailto:|tel:)/i.test(url)) return url;
  if (url.startsWith('//')) return `https:${url}`;
  return `https://${url}`;
}
